import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, Icon } from "semantic-ui-react";

export const SurveySubmitButton = ({ loading, intlId, ...others }) => (
  <Button
    loading={loading}
    disabled={loading}
    color="grey"
    size="large"
    icon
    {...others}
  >
    <Button.Content>
      <Icon name="send" />
      <FormattedMessage id="survey.submit" />
    </Button.Content>
  </Button>
);
